var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13301_253764)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.9769,
    cy: 5.83333,
    rx: 0.833333,
    ry: 0.833333,
    fill: "#1F2937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1436 8.33464H10.9769V14.168M19.3102 10.0013C19.3102 14.6037 15.5793 18.3346 10.9769 18.3346C6.37452 18.3346 2.64355 14.6037 2.64355 10.0013C2.64355 5.39893 6.37452 1.66797 10.9769 1.66797C15.5793 1.66797 19.3102 5.39893 19.3102 10.0013Z",
    stroke: "#1F2937",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13301_253764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.93221781.svg";
export { ForwardRef as ReactComponent };